var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSpaner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.979 18.979L29.257 24.257C29.6511 24.6509 29.9636 25.1186 30.1769 25.6334C30.3902 26.1481 30.4999 26.6998 30.4999 27.257C30.4999 27.8142 30.3902 28.3659 30.1769 28.8806C29.9636 29.3954 29.6511 29.8631 29.257 30.257C28.8631 30.651 28.3954 30.9636 27.8807 31.1769C27.3659 31.3901 26.8142 31.4999 26.257 31.4999C25.6998 31.4999 25.1481 31.3901 24.6334 31.1769C24.1186 30.9636 23.6509 30.651 23.257 30.257L18.312 25.312",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.979 18.979L29.257 24.257C29.6511 24.6509 29.9636 25.1186 30.1769 25.6334C30.3902 26.1481 30.4999 26.6998 30.4999 27.257C30.4999 27.8142 30.3902 28.3659 30.1769 28.8806C29.9636 29.3954 29.6511 29.8631 29.257 30.257C28.8631 30.651 28.3954 30.9636 27.8807 31.1769C27.3659 31.3901 26.8142 31.4999 26.257 31.4999C25.6998 31.4999 25.1481 31.3901 24.6334 31.1769C24.1186 30.9636 23.6509 30.651 23.257 30.257L18.312 25.312",
    stroke: "#6B6B6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.139 13.139L5.5 3.5L2.5 6.5L12.001 16.001",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.139 13.139L5.5 3.5L2.5 6.5L12.001 16.001",
    stroke: "#6B6B6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1341 5.866L27.5001 9.5L23.5001 5.5L27.1341 1.866C26.0066 1.47135 24.792 1.39554 23.6242 1.64691C22.4564 1.89828 21.3807 2.46708 20.5154 3.29066C19.6502 4.11425 19.029 5.16066 18.7203 6.31465C18.4117 7.46864 18.4275 8.68543 18.7661 9.831L2.15206 24.984C1.9523 25.1662 1.79158 25.3871 1.67959 25.6332C1.56761 25.8793 1.50669 26.1456 1.50052 26.4159C1.49435 26.6862 1.54306 26.955 1.6437 27.2059C1.74434 27.4569 1.89483 27.6848 2.08606 27.876L5.12406 30.914C5.31522 31.1052 5.54316 31.2557 5.79413 31.3564C6.04509 31.457 6.31385 31.5057 6.58417 31.4995C6.85449 31.4934 7.12076 31.4324 7.36687 31.3205C7.61298 31.2085 7.83382 31.0478 8.01606 30.848L23.1691 14.234C24.3147 14.5737 25.532 14.5904 26.6866 14.2821C27.8411 13.9739 28.8881 13.3527 29.712 12.4871C30.5359 11.6215 31.1047 10.5452 31.3556 9.37686C31.6065 8.2085 31.5299 6.99354 31.1341 5.866V5.866Z",
    stroke: "#6B6B6B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 24.406,
    y1: 18.979,
    x2: 24.406,
    y2: 31.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9984D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB563"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 8.8195,
    y1: 3.5,
    x2: 8.8195,
    y2: 16.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9984D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFB563"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpaner);
export default __webpack_public_path__ + "static/media/spaner.b9cefb8415ee1641f3f27d92a04e6bc8.svg";
export { ForwardRef as ReactComponent };